export default __webpack_public_path__ + "static/media/video-background.055df363.mp4";